export interface IAdvertisementPlacement {
    id: string;
    type: AdvertisementType;
}

export enum AdvertisementType {
    INTERSTITIAL = 'interstitial',
    REWARDED = 'rewarded',
}

export interface IAdvertisementPayload {
    g_gameArea: AdvertisementArea;
    g_rewardType: RewardType;
    [key: string]: any;
}

export enum RewardType {
    SHOP_COINS_100 = 'shop_coins_100',
    COINS_100 = 'coins_100',
    NONE = 'none',
    LIVES_1 = 'lives_1',
    PLUS_FIVE_CARDS = 'plus_five_cards',
    THREE_STAR_REWARD = 'three_star_reward',
    MISSION_SKIP = 'mission_skip',
    PRIZE_WHEEL_SPIN = 'prize_wheel_spin',
}

export enum AdvertisementArea {
    PRIZE_WHEEL = 'prize_wheel',
    MISSION_SKIP = 'mission_skip',
    THREE_STAR_REWARD_MENU = 'three_star_reward_menu',
    SHOP_100_COINS = 'shop_100_coins',
    LEVEL_PLUS_FIVE_CARDS = 'level_plus_five_cards',
    LEVEL_COMPLETE = 'level_complete',
    NO_LIVES_MENU = 'no_lives_menu',
    NO_COINS_MENU = 'no_coins_menu',
}
